type programInformation = {
    programName: string,
    inputParameterClass?: string,
    inputParameterNames?: string[]
}

type programInformations = {
    [name: string]: programInformation
}

const programs: programInformations = {
    RCPRC003: {
        programName: 'com.optum.file.prcpriceschedule.program.rcprc003dsppricesched.IRcprc003DspPriceSchedService',
        inputParameterNames: ["mediatorId","prcPriceScheduleName"],
        inputParameterClass: 'com.optum.file.prcpriceschedule.program.rcprc003dsppricesched.Rcprc003DspPriceSchedParams'
    },
    RCPTF031: {
        programName: 'com.optum.file.ptfpricingtable.program.rcptf031dsppricingtabl.IRcptf031DspPricingTablService'
    },
    RCDC3001: {
        programName: 'com.optum.file.dc3drugcostschedule.program.rcdc3001drugcostsched.IRcdc3001DrugCostSchedService'
    },
    RCDC5001: {
        programName: 'com.optum.file.dc5drugcostcompsched.program.rcdc5001mntdrgcmpcst.IRcdc5001MntdrgcmpcstService'
    },
    RCPS7001: {
        programName: 'com.optum.file.ps7pricebasisschedule.program.rcps7001dspprcbassch.IRcps7001DspPrcBasSchService'
    },
    RCMCL001: {
        programName: 'com.optum.file.mclmaclist.program.rcmcl001dispmaclists.IRcmcl001DispMacListsService'
    },
    RCMCP001I: {
        programName: 'com.optum.file.mcpmaclistproducts.program.rcmcp001iacmacprodbygpi.IRcmcp001iAcmacProdbygpiService',
        inputParameterClass: 'com.optum.file.mcpmaclistproducts.program.rcmcp001iacmacprodbygpi.Rcmcp001iAcmacProdbygpiParams',
        inputParameterNames: ["carCarrierId", "macList", "macListName", "wrkCarrierName"]
    },
    RCMLS001: {
        programName: 'com.optum.file.mlsmaclistschedule.program.rcmls001mntmls.IRcmls001MntMlsService'
    },
    RCMLI001: {
        programName: 'com.optum.file.mlimaclistschedident.program.rcmli001mntmli.IRcmli001MntMliService'
    },
    RCTAX001: {
        programName: 'com.optum.file.taxtaxschedule.program.rctax001disptaxsched.IRctax001DispTaxSchedService'
    },
    RCWSH001: {
        programName: 'com.optum.file.wshwithholdschedule.program.rcwsh001mntwithholdsch.IRcwsh001MntWithholdSchService'
    },
    RCADS001: {
        programName: 'com.optum.file.adsamountdueschedule.program.rcads001mntamtduesch.IRcads001MntAmtDueSchService'
    },
    RCFSH001: {
        programName: 'com.optum.file.fshfeescheduleheader.program.rcfsh001maintfeesched.IRcfsh001MaintFeeSchedService'
    },
    RCSFS001: {
        programName: 'com.optum.file.sfsstatefeeschedule.program.rcsfs001dspstfeescact.IRcsfs001DspStfeescActService'
    },
    RCSFT001: {
        programName: 'com.optum.file.sftprofservicefeetbl.program.rcsft001mntprfsrvfee.IRcsft001MntPrfSrvFeeService'
    },
    RCSFH001: {
        programName: 'com.optum.file.sfhprfsrvfeeschedhdr.program.rcsfh001mntprfsrvfeesch.IRcsfh001MntPrfsrvfeeschService'
    },
    RCAFS001: {
        programName: 'com.optum.file.afsadminfeeschedule.program.rcafs001mntadminfeesc.IRcafs001MntAdminFeeScService'
    },
    RCAFR001: {
        programName: 'com.optum.file.afradminfeeprofile.program.rcafr001mntadminfeeprof.IRcafr001MntAdminfeeprofService'
    },
    RCRMT001: {
        programName: 'com.optum.file.rmtretailandmailtable.program.rcrmt001dsprmtmaint.IRcrmt001DspRmtMaintService'
    },
    RCTRC001: {
        programName: 'com.optum.file.trctaxratecodetable.program.rctrc001dsptrcmntactv.IRctrc001DspTrcMntActvService'
    },
    RCSPT001: {
        programName: 'com.optum.file.sptstatepricingtable.program.rcspt001dspsptmntactv.IRcspt001DspSptMntActvService'
    },
    RCRBL001: {
        programName: 'com.optum.file.rblposrebatelist.program.rcrbl001mntrbl.IRcrbl001MntRblService'
    },
    RCRP1001: {
        programName: 'com.optum.file.rp1rxpriceschedule.program.rcrp1001mntrxpriceschd.IRcrp1001MntRxpriceSchdService'
    },
    RCRRD001: {
        programName: 'com.optum.file.rrdrxrestrictionsched.program.rcrrd001dsprestrctnschd.IRcrrd001DsprestrctnSchdService'
    },
    RCNRB001: {
        programName: 'com.optum.file.nrbphrmntwkrateschedule.program.rcnrb001phrmntwkratesch.IRcnrb001PhrmntwkRateschService'
    },
    RCSCH001: {
        programName: 'com.optum.file.schsourcecodeheader.program.rcsch001dispcostsrctyl.IRcsch001DispCostsrctyLService'
    },
    RCTXP001: {
        programName: 'com.optum.file.txptaxtableforpharntw.program.rctxp001mnttaxandphar.IRctxp001MntTaxAndPharService'
    },
    RCDXR001: {
        programName: 'com.optum.file.dxrpartdposrebate.program.rcdxr001prtdrebateact.IRcdxr001PrtdRebateActService'
    },
    RCRT1001I: {
        programName: 'com.optum.file.realtimepricing.program.rcrt1001idsprealtimepricingprofile.IRcrt1001iDspRealTimePricingService'
    },
    RCPRC004: {
        programName: 'com.optum.file.prcpriceschedule.program.rcprc004editpricesched.IRcprc004EditPriceSchedService',
        inputParameterNames: ["prcPriceScheduleName","workInitialProgramMode","prcPriceScheduleDesc","hiddenRecordIndicator","mediatorId"],
        inputParameterClass: 'com.optum.file.prcpriceschedule.program.rcprc004editpricesched.Rcprc004EditPriceSchedParams'
    },
    RCRBL005: {
        programName: 'com.optum.file.rblposrebatelist.program.rcrbl005selrbl.IRcrbl005SelRblService',
        inputParameterNames: ["rblRebateListId"],
        inputParameterClass: 'com.optum.file.rblposrebatelist.program.rcrbl005selrbl.Rcrbl005SelRblParams'
    },
    RCRBP001: {
        programName: 'com.optum.file.rbpposrebatelistprod.program.rcrbp001mntrbpact.IRcrbp001MntRbpActService',
        inputParameterNames: ["rblListDescription","rblRebateListId"],
        inputParameterClass: 'com.optum.file.rbpposrebatelistprod.program.rcrbp001mntrbpact.Rcrbp001MntRbpActParams'
    },
    RCDXR004: {
        programName: 'com.optum.file.dxrpartdposrebate.program.rcdxr004selprtdposreb.IRcdxr004SelPrtdPosRebService',
        inputParameterNames: ["dxrRebateTableId"],
        inputParameterClass: 'com.optum.file.dxrpartdposrebate.program.rcdxr004selprtdposreb.Rcdxr004SelPrtdPosRebParams'
    },
    RCDXP001: {
        programName: 'com.optum.file.dxppartdposrebatedtl.program.rcdxp001mntposrbtact.IRcdxp001MntPosRbtActService',
        inputParameterNames: ["dxrRebateDescription","dxrRebateTableId"],
        inputParameterClass: 'com.optum.file.dxppartdposrebatedtl.program.rcdxp001mntposrbtact.Rcdxp001MntPosRbtActParams'
    },
    RCDXT006: {
        programName: 'com.optum.file.dxtposrebateexclusion.program.rcdxt006selexclusionid.IRcdxt006SelExclusionIdService',
        inputParameterNames: ["dxtExclusionTableId"],
        inputParameterClass: 'com.optum.file.dxtposrebateexclusion.program.rcdxt006selexclusionid.Rcdxt006SelExclusionIdParams'
    },
    RCDXT003I: {
        programName: 'com.optum.file.dxtposrebateexclusion.program.rcdxt003idspposrbtex.IRcdxt003iDspPosRbtExService',
        inputParameterNames: ["dxtExclusionTableId"],
        inputParameterClass: 'com.optum.file.dxtposrebateexclusion.program.rcdxt003idspposrbtex.Rcdxt003iDspPosRbtExParams'
    },
    RCADS004: {
        programName: 'com.optum.file.adsamountdueschedule.program.rcads004sltamtduesch.IRcads004SltAmtDueSchService',
        inputParameterNames: ["adsScheduleId"],
        inputParameterClass: 'com.optum.file.adsamountdueschedule.program.rcads004sltamtduesch.Rcads004SltAmtDueSchParams'
    },
    RCADS003I: {
        programName: 'com.optum.file.adsamountdueschedule.program.rcads003idspamtduesch.IRcads003iDspAmtDueSchService',
        inputParameterNames: ["adsScheduleId"],
        inputParameterClass: 'com.optum.file.adsamountdueschedule.program.rcads003idspamtduesch.Rcads003iDspAmtDueSchParams'
    },
    RCTAX005: {
        programName: 'com.optum.file.taxtaxschedule.program.rctax005selecttaxsched.IRctax005SelectTaxSchedService',
        inputParameterNames: ["taxCountyCode", "taxSeqNbr", "taxTaxScheduleName", "taxTaxScheduleState", "taxTaxScheduleZip", "taxTaxScheduleZip2", "taxTaxScheduleZip3"],
        inputParameterClass: 'com.optum.file.taxtaxschedule.program.rctax005selecttaxsched.Rctax005SelectTaxSchedParams'
    },
    RCGP1004: {
        programName: 'com.optum.file.gp1gpilist.program.rcgp1004selectgpilist.IRcgp1004SelectGpiListService',
        inputParameterNames: ["gpiListId"],
        inputParameterClass: 'com.optum.file.gp1gpilist.program.rcgp1004selectgpilist.Rcgp1004SelectGpiListParams'
    },
    RCGP1003I: {
        programName: 'com.optum.file.gp1gpilist.program.rcgp1003idspgpilist.IRcgp1003iDspGpiListService',
        inputParameterNames: ["gpiListId"],
        inputParameterClass: 'com.optum.file.gp1gpilist.program.rcgp1003idspgpilist.Rcgp1003iDspGpiListParams'
    },
    RCPRC001: {
        programName: 'com.optum.file.prcpriceschedule.program.rcprc001slctpricesched.IRcprc001SlctPriceSchedService',
        inputParameterNames: ["prcPriceScheduleName"],
        inputParameterClass: 'com.optum.file.prcpriceschedule.program.rcprc001slctpricesched.Rcprc001SlctPriceSchedParams'
    },
    RCPAL004: {
        programName: 'com.optum.file.palpharmacyidlist.program.rcpal004selectpallist.IRcpal004SelectPalListService',
        inputParameterNames: ["palPharmacyIdListName"],
        inputParameterClass: 'com.optum.file.palpharmacyidlist.program.rcpal004selectpallist.Rcpal004SelectPalListParams'
    },
    RCPAD001I: {
        programName: 'com.optum.file.padpharmacyidlistdtl.program.rcpad001idsppadlstdtl.IRcpad001idspPadLstDtlService',
        inputParameterNames: ["palPharmacyIdListDesc", "palPharmacyIdListName"],
        inputParameterClass: 'com.optum.file.padpharmacyidlistdtl.program.rcpad001idsppadlstdtl.Rcpad001idspPadLstDtlParams'
    },
    RCPS7005I: {
        programName: 'com.optum.file.ps7pricebasisschedule.program.rcps7005idspprcbassch.IRcps7005iDspPrcBasSchService',
        inputParameterNames: ["ps7PriceBasisSched"],
        inputParameterClass: 'com.optum.file.ps7pricebasisschedule.program.rcps7005idspprcbassch.Rcps7005iDspPrcBasSchParams'
    },
    RCMLS003: {
        programName: 'com.optum.file.mlsmaclistschedule.program.rcmls003edtmls.IRcmls003EdtMlsService',
        inputParameterNames: ["mlsSchedule"],
        inputParameterClass: 'com.optum.file.mlsmaclistschedule.program.rcmls003edtmls.Rcmls003EdtMlsParams'
    },
    RCFSC004I: {
        programName: 'com.optum.file.fscfeeschedule.program.rcfsc004idspfeeschstp.IRcfsc004iDspFeeSchStpService',
        inputParameterNames: ["fscFeeScheduleName", "fscStepNbrInFeeSched", "fshFeeScheduleDesc"],
        inputParameterClass: 'com.optum.file.fscfeeschedule.program.rcfsc004idspfeeschstp.Rcfsc004iDspFeeSchStpParams'
    },
    RCTAX004: {
        programName: 'com.optum.file.taxtaxschedule.program.rctax004disptaxsched.IRctax004DispTaxSchedService',
        inputParameterNames: ["taxCountyCode", "taxSeqNbr", "taxTaxScheduleName", "taxTaxScheduleState", "taxTaxScheduleZip", "taxTaxScheduleZip2", "taxTaxScheduleZip3"],
        inputParameterClass: 'com.optum.file.taxtaxschedule.program.rctax004disptaxsched.Rctax004DispTaxSchedParams'
    },
    RCNRB003: {
        programName: 'com.optum.file.nrbphrmntwkrateschedule.program.rcnrb003chgphnwratesch.IRcnrb003ChgPhnWrateschService',
        inputParameterNames: ["nrbScheduleDescription","nrbScheduleName","workInitialProgramMode"],
        inputParameterClass: 'com.optum.file.nrbphrmntwkrateschedule.program.rcnrb003chgphnwratesch.Rcnrb003ChgPhnWrateschParams'
    },
    RCNRC001I: {
        programName: 'com.optum.file.nrcphrmntwkrateschdtl.program.rcnrc001idsprateactive.IRcnrc001iDspRateActiveService',
        inputParameterNames: ["nrbScheduleDescription","nrbScheduleName"],
        inputParameterClass: 'com.optum.file.nrcphrmntwkrateschdtl.program.rcnrc001idsprateactive.Rcnrc001iDspRateActiveParams'
    },
    RCGP2001I: {
        programName: 'com.optum.file.gp2gpilistdetail.program.rcgp2001idspbygpinbr.IRcgp2001iDspByGpiNbrService',
        inputParameterNames: ["gp1GpiListDescription", "gpiListId","gp2GpiDescription"],
        inputParameterClass: 'com.optum.file.gp2gpilistdetail.program.rcgp2001idspbygpinbr.Rcgp2001iDspByGpiNbrParams'
    },
    RCFSN001I: {
        programName: 'com.optum.file.fsnfeeschedulenotes.program.rcfsn001idspfeeschnot.IRcfsn001iDspFeeSchNotService',
        inputParameterNames:["fshFeeScheduleDesc", "fshFeeScheduleId"],
        inputParameterClass: 'com.optum.file.fsnfeeschedulenotes.program.rcfsn001idspfeeschnot.Rcfsn001iDspFeeSchNotParams'
    },
    RCFSH003I: {
        programName: 'com.optum.file.fshfeescheduleheader.program.rcfsh003idspfeesched.IRcfsh003iDspFeeSchedService',
        inputParameterNames:["fshFeeScheduleId"],
        inputParameterClass: 'com.optum.file.fshfeescheduleheader.program.rcfsh003idspfeesched.Rcfsh003iDspFeeSchedParams'
    },
    RCFSC002I: {
        programName: 'com.optum.file.fscfeeschedule.program.rcfsc002idspfeeschstp.IRcfsc002iDspFeeSchStpService',
        inputParameterNames:["fscFeeScheduleName", "fshFeeScheduleDesc"],
        inputParameterClass: 'com.optum.file.fscfeeschedule.program.rcfsc002idspfeeschstp.Rcfsc002iDspFeeSchStpParams'
    },
    RCFSN001 : {
        programName: 'com.optum.file.fsnfeeschedulenotes.program.rcfsn001mntfeeschnote.IRcfsn001MntFeeSchNoteService',
        inputParameterNames:["fshFeeScheduleDesc", "fshFeeScheduleId", "workInitialProgramMode"],
        inputParameterClass: 'com.optum.file.fsnfeeschedulenotes.program.rcfsn001mntfeeschnote.Rcfsn001MntFeeSchNoteParams'
    },
    RCPID009 : {
        programName: 'com.optum.file.pidproductid.program.rcpid009prodbygpiact.IRcpid009ProdByGpiActService',
        inputParameterNames:["gpiIdNumber"],
        inputParameterClass: 'com.optum.file.pidproductid.program.rcpid009prodbygpiact.Rcpid009ProdByGpiActParams'
    },
    RCMD1001 : {
        programName: 'com.optum.file.md1maclistscheddetail.program.rcmd1001dspmd1active.IRcmd1001DspMd1ActiveService',
        inputParameterNames:["mlsDescription","mlsSchedule"],
        inputParameterClass: 'com.optum.file.md1maclistscheddetail.program.rcmd1001dspmd1active.Rcmd1001DspMd1ActiveParams'
    },
    RCPSC002 : {
        programName: 'com.optum.file.pscpriceschedcriteria.program.rcpsc002prcschcrtmnt.IRcpsc002PrcschcrtMntService',
        inputParameterNames:["prcPriceScheduleDesc","prcPriceScheduleName"],
        inputParameterClass: 'com.optum.file.pscpriceschedcriteria.program.rcpsc002prcschcrtmnt.Rcpsc002PrcschcrtMntParams'
    },
    RCPS8001 : {
        programName: 'com.optum.file.ps8pricebasisdetail.program.rcps8001dspprcbasdtl.IRcps8001DspPrcBasDtlService',
        inputParameterNames:["ps7PriceBasisDescrip","ps7PriceBasisSched"],
        inputParameterClass: 'com.optum.file.ps8pricebasisdetail.program.rcps8001dspprcbasdtl.Rcps8001DspPrcBasDtlParams'
    },
    RCRBL003 : {
        programName: 'com.optum.file.rblposrebatelist.program.rcrbl003edtrbl.IRcrbl003EdtRblService',
        inputParameterNames:["rblRebateListId","workInitialProgramMode"],
        inputParameterClass: 'com.optum.file.rblposrebatelist.program.rcrbl003edtrbl.Rcrbl003EdtRblParams'
    },
    RCSTL002I : {
        programName: 'com.optum.file.stlstatelist.program.rcstl002idspstatelist.IRcstl002iDspStateListService',
        inputParameterNames:["stlStateListName"],
        inputParameterClass: 'com.optum.file.stlstatelist.program.rcstl002idspstatelist.Rcstl002iDspStateListParams'
    },
    RCGRP016 : {
        programName: 'com.optum.file.grpgroup.program.rcgrp016selectgroup.IRcgrp016SelectGroupService',
        inputParameterNames:["accAccountId","carCarrierId","grpGroupId"],
        inputParameterClass: 'com.optum.file.grpgroup.program.rcgrp016selectgroup.Rcgrp016SelectGroupParams'
    },
    RCGRP030 : {
        programName: 'com.optum.file.grpgroup.program.rcgrp030selectgroup.IRcgrp030SelectGroupService',
        inputParameterNames:["accAccountId","carCarrierId","grpGroupId","wrkFKeySts"],
        inputParameterClass: 'com.optum.file.grpgroup.program.rcgrp030selectgroup.Rcgrp030SelectGroupParams'
    },
    RCGRP031 : {
        programName: 'com.optum.file.grpgroup.program.rcgrp031selgrpbyacct.IRcgrp031SelGrpByAcctService',
        inputParameterNames:["accAccountId","carCarrierId","grpGroupId","wrkFKeySts"],
        inputParameterClass: 'com.optum.file.grpgroup.program.rcgrp031selgrpbyacct.Rcgrp031SelGrpByAcctParams'
    },
    RCPID015:{
        programName: 'com.optum.file.pidproductid.program.rcpid015sellblnmact.IRcpid015SelLblNmActService',
        inputParameterClass: 'com.optum.file.pidproductid.program.rcpid015sellblnmact.Rcpid015SelLblNmActParams',
        inputParameterNames: ["prdDescriptionAbbrev"]        
    },
     RCPID013:{
        programName: 'com.optum.file.pidproductid.program.rcpid013prodbygppcact.IRcpid013ProdByGppcActService',
        inputParameterNames: ["gpiIdNumber","gpmGppcId"],
        inputParameterClass: 'com.optum.file.pidproductid.program.rcpid013prodbygppcact.Rcpid013ProdByGppcActParams'
               
    },
    RCCTY004:{
        programName: 'com.optum.file.ctyfipscounty.program.rccty004selbycode.IRccty004SelByCodeService',
        inputParameterNames: ["ctyStateAbbreviation","ctyCountyCode","ctyCountyName"],
        inputParameterClass: 'com.optum.file.ctyfipscounty.program.rccty004selbycode.Rccty004SelByCodeParams'
    },
   RCTRC003:{
        programName: 'com.optum.file.trctaxratecodetable.program.rctrc003edtdsptrcmain.IRctrc003EdtDspTrcMainService',
        inputParameterNames: ["screenMode","trcSeqNbr","trcState","trcTaxRateCode"],
        inputParameterClass: 'com.optum.file.trctaxratecodetable.program.rctrc003edtdsptrcmain.Rctrc003EdtDspTrcMainParams'
    },
   RCCTY003:{
        programName: 'com.optum.file.ctyfipscounty.program.rccty003countycodedtl.IRccty003CountyCodeDtlService',
        inputParameterNames: ["ctyStateAbbreviation","ctyCountyCode","ctyCountyName"],
        inputParameterClass: 'com.optum.file.ctyfipscounty.program.rccty003countycodedtl.Rccty003CountyCodeDtlParams'
    },
   RCSTD001I:{
           programName: 'com.optum.file.stdstatelistdetail.program.rcstd001istatelistdtl.IRcstd001iStateListDtlService',
           inputParameterNames: ["stlStateListDesc","stlStateListName"],
           inputParameterClass: 'com.optum.file.stdstatelistdetail.program.rcstd001istatelistdtl.Rcstd001iStateListDtlParams'
       },
    RCPIW007:{
           programName: 'com.optum.file.piwproductidworkfile.program.rcpiw007prodbyndcact.IRcpiw007ProdByNdcActService',
           inputParameterNames: ["gpiName","gpiNumber"],
           inputParameterClass: 'com.optum.file.piwproductidworkfile.program.rcpiw007prodbyndcact.Rcpiw007ProdByNdcActParams'
       },
    RCREJ001:{
           programName: 'com.optum.file.rejrejectcodes.program.rcrej001slctrejectcode.IRcrej001SlctRejectCodeService',
           inputParameterNames: ["rejRejectCode"],
           inputParameterClass: 'com.optum.file.rejrejectcodes.program.rcrej001slctrejectcode.Rcrej001SlctRejectCodeParams'
       },  
    RCGPI900:{
        programName: 'com.optum.file.gpimedispangpi.program.rcgpi900selfullgpiname.IRcgpi900SelFullgpiNameService',
        inputParameterClass: 'com.freschesolutions.synon2java.service.data.EmptyParam',
        inputParameterNames: []        
    },
    RCGPM900:{
        programName: 'com.optum.file.gpmgppcmaster.program.rcgpm900selectgppcactv.IRcgpm900SelectGppcActvService',
        inputParameterClass: 'com.optum.file.gpmgppcmaster.program.rcgpm900selectgppcactv.Rcgpm900SelectGppcActvParams',
        inputParameterNames: ["gpiIdNumber","gpmGppcId"]        
    },
    RCCSS001: {
        programName: 'com.optum.file.csscostsourceandtype.program.rccss001selcstsrctyp.IRccss001SelCstSrcTypService',
        inputParameterClass: 'com.optum.file.csscostsourceandtype.program.rccss001selcstsrctyp.Rccss001SelCstSrcTypParams',
        inputParameterNames: ["cssCostSource", "cssCostType"]
    },
    RCCSS006: {
        programName: 'com.optum.file.csscostsourceandtype.program.rccss006selcstsrctypa.IRccss006SelCstSrcTypaService',
        inputParameterClass: 'com.optum.file.csscostsourceandtype.program.rccss006selcstsrctypa.Rccss006SelCstSrcTypaParams',
        inputParameterNames: ["cssCostSource", "cssCostType", "cssStatePricing"]
    },
    RCGPM003I:{
        programName: 'com.optum.file.gpmgppcmaster.program.rcgpm003idspgppcmaster.IRcgpm003iDspGppcMasterService',
        inputParameterClass: 'com.optum.file.gpmgppcmaster.program.rcgpm003idspgppcmaster.Rcgpm003iDspGppcMasterParams',
        inputParameterNames: ["gpiIdNumber","gpmGppcId"]        
    },
    RCGIN004:{
        programName: 'com.optum.file.gingenericidnotes.program.rcgin004editgppcnotes.IRcgin004EditGppcNotesService',
        inputParameterClass: 'com.optum.file.gingenericidnotes.program.rcgin004editgppcnotes.Rcgin004EditGppcNotesParams',
        inputParameterNames: ["ginGenericIdNumber","ginGenericType"]        
    },
    RCRAD003I:{
        programName: 'com.optum.file.radrouteofadmin.program.rcrad003idsprouteadmin.IRcrad003iDspRouteAdminService',
        inputParameterClass: 'com.optum.file.radrouteofadmin.program.rcrad003idsprouteadmin.Rcrad003iDspRouteAdminParams',
        inputParameterNames: ["radRouteOfAdminCode"]        
    },
    RCDF2001:{
        programName: 'com.optum.file.df2dosageformnarrative.program.rcdf2001displaydosnarr.IRcdf2001DisplayDosNarrService',
        inputParameterClass: 'com.optum.file.df2dosageformnarrative.program.rcdf2001displaydosnarr.Rcdf2001DisplayDosNarrParams',
        inputParameterNames: ["df1DosageFormCode"]
    },
    RCCSS005:{
        programName: 'com.optum.file.csscostsourceandtype.program.rccss005dspcstsrctyp.IRccss005DspCstSrcTypService',
        inputParameterClass: 'com.optum.file.csscostsourceandtype.program.rccss005dspcstsrctyp.Rccss005DspCstSrcTypParams',
        inputParameterNames: ["cssCostSource","cssCostType","cssStatePricing"]
    },
    RC3EX003I:{
        programName: 'com.optum.file.x3ex3rdpartyexception.program.rc3ex003idsp3rdptyexcp.IRc3ex003iDsp3rdPtyExcpService',
        inputParameterClass: 'com.optum.file.x3ex3rdpartyexception.program.rc3ex003idsp3rdptyexcp.Rc3ex003iDsp3rdPtyExcpParams',
        inputParameterNames: ["x3ex3rdPartyExcpCode"]
    },
    RCMCC001: {
        programName: 'com.optum.file.mccmaclistcosthistory.program.rcmcc001mntmaccstsact.IRcmcc001MntmacCstsActService',
        inputParameterClass: 'com.optum.file.mccmaclistcosthistory.program.rcmcc001mntmaccstsact.Rcmcc001MntmacCstsActParams',
        inputParameterNames: ["carCarrierId", "macGenericName", "macGpi", "macGppc", "macList", "macListName", "macNdcLabelerId", "macNdcPackageCode", "macNdcProductCode", "wrkCarrierName", "modeFromPreviousScreen"]
    },
    RCRT2001I: {
        programName: 
        'com.optum.file.realtimepricingprofilerule.program.rcrt2001idsprealtimepricingprofilerules.IRcrt2001iDspRealTimePricingProfileRulesService',
        inputParameterClass: 
        'com.optum.file.realtimepricingprofilerule.program.rcrt2001idsprealtimepricingprofilerules.Rcrt2001iDspRealTimePricingProfileRulesParams',
        inputParameterNames: ["rt1AccountId", "planCode", "planEffDate", "rt1CarrierId", "rt1GroupId",
             "wrkRt1AccountId", "wrkRt1CarrierId", "wrkRt1GroupId", "wrkPlanCode", "wrkPlanEffDate", "mediatorId"]
    }
};

export function getProgramParameters(programName: string): programInformation | undefined {
    return programs[programName];
}


export function getProgramUrl(programName: string, parameters?: string[]): string | undefined {
    // get program informations
    let url = undefined;
    // return program url
        const encodedParameters: string[] = parameters && parameters.length > 0 ? parameters.map(elt=> encodeURIComponent(elt as string)) : [];
        const urlParameters = encodedParameters.length > 0 ? "/" + encodedParameters.join("/") : "";
        url = `/program/${programName}${urlParameters}`
    
    console.log("Navigating to " + url);
    return url;
}

